import React from "react";
import ReportDetail from "../ReportDetail";
import CustomersReport from "./CustomersReport";

const Customers = () => {
  return (
    <ReportDetail title="customers_report">
      <CustomersReport />
    </ReportDetail>
  );
};

export default Customers;
